 'use strict';
import Vue from 'vue';
import '../css/mixins/variables.css';
import auth from './utils/auth';
import en from 'vee-validate/dist/locale/en.json';
import PdfViewer from './components/pdf.vue';
import trailers from './components/trailers.vue';
import team from './components/team.vue';
import icon from './components/icon.vue';
import casting from './components/casting.vue';
import howling from './components/howling.vue';
import gallery from './components/gallery.vue';
import VueTinyLazyloadImg from 'vue-tiny-lazyload-img';
import ready from './utils/ready'; // eslint-disable-line no-unused-vars
import {
    ValidationObserver,
    ValidationProvider,
    extend,
    localize
} from 'vee-validate';
import {
    required,
    min
} from 'vee-validate/dist/rules';
import {
    info // eslint-disable-line no-unused-vars
} from './utils/debug';

// Install validation rules
extend('required', required);
extend('min', min);

// Install validation messages
localize({
  en
});

Vue.component('validationobserver', ValidationObserver); // eslint-disable-line vue/component-definition-name-casing
Vue.component('validationprovider', ValidationProvider); // eslint-disable-line vue/component-definition-name-casing
Vue.config.debug = process.env.NODE_ENV === 'development';
Vue.config.devtools = process.env.NODE_ENV === 'development';
Vue.use(VueTinyLazyloadImg);
new Vue({
    el: '#app',
    delimiters: ['${', '}'], // Delimiters changed to ES6 template string style because of hugo GO templating
    components: {
        PdfViewer,
        trailers,
        team,
        casting,
        howling,
        gallery,
        icon
    },
    data() {
        return {
            name: '',
            isAnAlchemist: typeof window !== 'undefined' && auth.currentUser(),
            alchemistRole: null,
            login: {
                altEmail: 'caravan@nationallampoon.com',
                mainEmail: 'caravan@nationallampoon.com',
                password: null,
                errors: [],
                submitting: false,
                submitted: false
            },
            navHeight: 120,
            firstScroll: true,
            ticking: false,
            distanceFromTop: window.pageYOffset,
            lastDistanceFromTop: window.pageYOffset,
            scrollingUp: null,
            scrollingDown: null
        };
    },
    created() {
        window.requestAnimationFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
        const self = this;

        if (window.location.pathname === '/logout/') {
            self.logoutAlchemist();
        }

        if (self.isAnAlchemist) {
            self.alchemistRole = auth.currentUser().app_metadata.roles[0];

            switch (self.alchemistRole) {
                case 'caravan':
                    console.log('Welcome Alchemist');
                break;
                default:
                    self.isAnAlchemist.logout().then(() => {
                        window.location = '/';
                    });
            }
        }

        setTimeout(function initBindScrolling() {
            if (self.distanceFromTop === 0) {
                self.onScroll();
            }

            window.addEventListener('scroll', function bindScrolling() {
                if (!self.ticking) {

                    window.requestAnimationFrame(function rafScroll() {
                        self.onScroll();
                        self.ticking = false;
                    });

                    self.ticking = true;

                }
            });
        }, 100);

        return;
    },
    destroyed() {
        window.removeEventListener('scroll', this.onScroll);
    },
    methods: {
        handleAffix() {
            this.setScrollingDirection();
            this.lastDistanceFromTop = this.distanceFromTop;
        },
        logoutAlchemist() {
            const self = this;
            if (self.isAnAlchemist) {
                self.isAnAlchemist.logout().then(() => {
                    self.alchemistRole = null;
                    window.location = '/';
                })
                .catch((error) => {
                    console.log('an error', error);
                });
            }

            return;
        },
        onScroll() {
            this.setDynamicVariables();

            if (this.firstScroll) {
                this.firstScroll = false;
                return;
            }

            if (this.scrollingUp) {
                this.$el.classList.remove('scrolling-down');

                if (this.distanceFromTop >= this.navHeight * 2) {
                    this.$el.classList.add('scrolling-up');
                }
                else {
                    if (this.distanceFromTop === 0) {
                        this.$el.classList.remove('scrolling-up');
                    }
                }
            }
            else {
                if (this.distanceFromTop >= this.navHeight) {
                    this.$el.classList.remove('scrolling-up');
                    this.$el.classList.add('scrolling-down');
                }
            }

            this.handleAffix();
        },
        setDynamicVariables() {
            this.distanceFromTop = window.pageYOffset;
            this.screenBottomPos = this.distanceFromTop + window.innerHeight;
        },
        setScrollingDirection() {
            if (this.distanceFromTop > this.lastDistanceFromTop) {
                this.scrollingDown = true;
                this.scrollingUp = false;
            }
            else {
                this.scrollingUp = true;
                this.scrollingDown = false;
            }
        },
        submitLoginForm() {
            const self = this;
            self.login.submitting = true;
            self.login.errors = [];

            let failAlt = true,
                failMain = true;

            const promise1 = auth.login(self.login.altEmail, self.login.password, true);
            const promise2 = auth.login(self.login.mainEmail, self.login.password, true);
            const promises = [promise1, promise2];

            Promise.allSettled(promises)
                .then((results) => {
                    failAlt = (results[0].status === 'rejected'); // eslint-disable-line no-extra-parens
                    failMain = (results[1].status === 'rejected'); // eslint-disable-line no-extra-parens
                    if (failAlt && failMain) {
                        self.login.errors.push('We are sorry, something has gone wrong. Please check your password and try again.');
                    }
                    else {
                        self.isAnAlchemist = true;
                        self.alchemistRole = auth.currentUser().app_metadata.roles[0];
                    }
                    self.login.submitted = false;
                    self.login.submitting = false;
                });
            return;
        }
    }
});
